import React from 'react';
import Text from '../../Base/Text/Text';
import Button from '../../Button/Button';
import { Theme } from '../../../Enums/Theme.enum';
import styles from './PatientProfileDataCompareTableRowItem.module.scss';
import { PATIENT_DATA_COMPARE_TABLE_TRANSLATIONS } from '../../../Helpers/Patient/compareTableTranslations.helper';
import { PatientDataCompareKey } from '../../../Helpers/Patient/mapPatientDataToCompareTable.helper';
import LinkButton from '../../Button/LinkButton';

type TranslationKey = keyof typeof PATIENT_DATA_COMPARE_TABLE_TRANSLATIONS;

interface Props {
	title: PatientDataCompareKey;
	value: string;
	compareTo?: string;
	overwriteData?: (key: string, value: string) => void;
}

const PatientProfileDataCompareTableRowItem = ({
	title,
	value,
	compareTo,
	overwriteData,
}: Props) => {
	const showOverwriteButton = overwriteData && value && value !== compareTo;

	return (
		<td>
			<div className={styles.cellWrapper}>
				<span className={styles.text}>{value || ''}</span>
				{showOverwriteButton && (
					<div className={styles.buttonContainer}>
						<LinkButton
							theme={Theme.BLUE}
							onClick={() => overwriteData(title, value)}
							title='patientTreatment.profile.compareData.takeOver'
						/>
					</div>
				)}
			</div>
		</td>
	);
};

export default PatientProfileDataCompareTableRowItem;
